import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

export default function OurDataToolbar({ search = true, searchVisible, toggleSearch, refreshCallback = null }) {
    const { t } = useTranslation();

    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />

            {search && (
            <Button color="primary" size="small"
                    startIcon={searchVisible ? <ClearIcon /> : <SearchIcon />}
                    onClick={toggleSearch}>
                    {t('Search|noun')}
                </Button>
            )}
            <GridToolbarDensitySelector />
            {refreshCallback !== null && (
                <Button color="primary" size="small"
                    startIcon={<RefreshIcon />}
                    onClick={refreshCallback}>
                    {t('Refresh')}
                </Button>
            )}
            <Box sx={{ flexGrow: 1 }} />
            <GridToolbarExport csvOptions={{ delimiter: ';' }} />
        </GridToolbarContainer>
    );
}